import { ShieldMark } from './Logo';

// Full-screen boot loader (first visit).
export default function Loader({ fading }) {
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center transition-opacity duration-500"
      style={{ background: 'var(--bg)', opacity: fading ? 0 : 1, pointerEvents: fading ? 'none' : 'auto' }}>
      <div className="absolute inset-0 gold-glow-soft" />
      <div className="relative flex flex-col items-center">
        <div className="relative flex items-center justify-center">
          <span className="loader-ring" />
          <ShieldMark size={62} />
        </div>
        <div className="mt-6 font-display text-[20px] font-bold tracking-[0.14em]">KALKI <span className="gold-text">AI</span></div>
        <div className="mt-5 w-40 h-[3px] rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,.08)' }}>
          <div className="loader-bar h-full" style={{ background: 'var(--gold-grad)' }} />
        </div>
      </div>
    </div>
  );
}

// Lightweight fallback for lazy-loaded routes.
export function PageLoader() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <div className="relative flex items-center justify-center"><span className="loader-ring" /><ShieldMark size={48} /></div>
    </div>
  );
}
